var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7556 41.0925C100.426 48.4283 99.1202 56.2318 97.8068 63.4064C96.4566 70.7839 94.1035 77.9658 89.2368 83.7093C84.3078 89.3967 77.9807 93.7003 70.8801 96.1949C63.5374 98.8674 56.1532 98.4753 48.9856 97.2462C41.5732 95.9956 34.8894 93.2321 29.12 88.4459C23.4837 83.8086 17.6266 78.5647 14.9566 71.2289C12.3067 63.9887 11.5885 56.1832 12.8729 48.581C14.2491 40.9588 17.5385 33.8107 22.4325 27.8072C27.1331 22.2584 34.0431 17.7456 41.3858 15.073C48.7285 12.4005 56.675 12.8408 63.8427 14.0699C71.2501 15.3393 78.1946 18.5298 83.9833 23.3228C89.5739 28.0082 95.0881 33.7638 97.7556 41.0925Z",
    fill: "#FF9FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1722 32.3641C57.812 38.1101 43.086 43.4699 28.392 48.2988L25.7812 49.1602L36.7601 79.3243L39.3116 78.3C53.6718 72.5541 68.3978 67.1943 83.0917 62.3654L85.6985 61.5122L74.7196 31.348L72.1722 32.3641ZM66.5278 40.3008L56.339 56.3069L37.9503 50.7022C47.5283 47.4347 57.0904 43.9544 66.5278 40.3008ZM39.8839 72.3459L33.5426 54.9232L58.6552 62.5761L72.5088 40.8158L78.826 58.1721C65.7621 62.5239 52.6888 67.2822 39.8839 72.3459Z",
    fill: "#FAFF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAlt);
export default __webpack_public_path__ + "static/media/mail-alt.7493fc622d9f63ddd8948cef25433f84.svg";
export { ForwardRef as ReactComponent };